/**
 * Сортировка массивов для отображения упорядоченных данных в списках
 */

export default function compareText(a,b) {
        let textA, textB;
    if (a.text && b.text){
        textA = a.text.toLowerCase();
        textB = b.text.toLowerCase();
    } else {
        textA = a.toLowerCase();
        textB = b.toLowerCase();
    }

        if (textA < textB)
            return -1;
        if (textA > textB)
            return 1;
        return 0
}



/** WEBPACK FOOTER **
 ** ./src/js/lib/sortArrays.js
 **/